export enum WriterFormatEnum {
  PlainText = 'plain-text',
    Markdown = 'markdown',
}
